export { default } from './flyer.component';
